import PuzzleCreate from '_modules/puzzle/views/PuzzleCreate.vue';
import PuzzleList from '_modules/puzzle/views/PuzzleList.vue';
import PuzzleEdit from '_modules/puzzle/views/PuzzleEdit.vue';
import Puzzles from './Root.vue';

export default {
  path: 'caca-palavras',
  name: 'puzzles',
  component: Puzzles,
  redirect: '/caca-palavras/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-puzzle-list',
      component: PuzzleList,
    },
    {
      path: 'novo',
      name: 'admin-puzzle-new',
      component: PuzzleCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-puzzle-edit',
      component: PuzzleEdit,
    },
  ],
};
